const { Component, Mixin } = Shopware;

Component.register('sellops-order-editing-config-redirect', {
    template: `
        {% block sellops_order_editing_config %}
        <sw-page class="sellops-order-editing-config">

            <template #smart-bar-header>
                <h2>{{ $tc('sellops-order-modification-tracking.general.configMenuLabel') }}</h2>
            </template>

            <template #smart-bar-actions>
                <sw-button variant="ghost" size="small" @click="goToModifications">
                    <sw-icon name="regular-list" size="16px" style="margin-right: 6px;"></sw-icon>
                    {{ $tc('sellops-order-modification-tracking.general.viewModificationsLink') }}
                </sw-button>
                <sw-button
                    variant="primary"
                    size="small"
                    :is-loading="isSaving"
                    @click="onSave"
                    style="margin-left: 8px;">
                    {{ $tc('global.default.save') }}
                </sw-button>
            </template>

            <template #content>
                <sw-card-view>
                    <sw-system-config
                        ref="systemConfig"
                        sales-channel-switchable
                        domain="SellopsLimitedOrderEditing.config"
                        @loading-changed="onLoadingChanged">
                    </sw-system-config>
                </sw-card-view>
            </template>

        </sw-page>
        {% endblock %}
    `,

    mixins: [
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            isSaving: false,
            isReady: false,
        };
    },

    methods: {
        goToModifications() {
            this.$router.push({ name: 'sellops.order.modification.tracking.list' });
        },

        validateConfig() {
            const systemConfig = this.$refs.systemConfig;
            if (!systemConfig || !systemConfig.actualConfigData) {
                return true;
            }

            // Only letters and spaces allowed — no numbers or special characters
            const onlyLettersAndSpaces = /^[a-zA-ZÀ-ÿ\s]*$/;

            // actualConfigData is keyed by sales channel id (null = global)
            for (const [salesChannelId, configValues] of Object.entries(systemConfig.actualConfigData)) {
                if (!configValues) continue;

                const label = configValues['SellopsLimitedOrderEditing.config.editableStateLabel'];

                if (label !== undefined && label !== null && label !== '') {
                    if (!onlyLettersAndSpaces.test(label)) {
                        this.createNotificationError({
                            title: this.$tc('global.default.error'),
                            message: '"Order status label while editable" must contain only letters and spaces — no numbers or special characters.',
                        });
                        return false;
                    }
                }
            }

            return true;
        },

        async onSave() {
            if (!this.validateConfig()) {
                return;
            }

            this.isSaving = true;
            try {
                await this.$refs.systemConfig.saveAll();
                this.createNotificationSuccess({
                    message: this.$tc('sw-plugin-config.saveSuccessMessage'),
                });
            } catch (e) {
                this.createNotificationError({
                    message: this.$tc('sw-plugin-config.saveErrorMessage'),
                });
            } finally {
                this.isSaving = false;
            }
        },

        onLoadingChanged(loading) {
            this.isSaving = loading;
            if (!loading && !this.isReady) {
                this.$nextTick(() => {
                    this.isReady = true;
                });
            }
        },
    },
});
